export default __webpack_public_path__ + "static/media/16.274095d5.jpg";